import { useEffect, useState } from 'react';

export function useServiceWorker() {
  const [registration, setRegistration] = useState(null);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Wait for service worker to be ready
      navigator.serviceWorker.ready
        .then((reg) => {
          console.log('✅ Service Worker ready:', reg.scope);
          setRegistration(reg);
          
          // Check for existing subscription
          return reg.pushManager.getSubscription();
        })
        .then((sub) => {
          if (sub) {
            console.log('✅ Existing subscription found:', sub);
            setSubscription(sub);
          } else {
            console.log('ℹ️ No existing subscription');
          }
        })
        .catch((error) => {
          console.error('❌ Service Worker error:', error);
        });
    }
  }, []);

  const subscribeToPush = async () => {
    console.log('📱 subscribeToPush called');
    
    // Wait for service worker to be ready if not already
    let reg = registration;
    if (!reg && 'serviceWorker' in navigator) {
      console.log('⏳ Waiting for service worker to be ready...');
      reg = await navigator.serviceWorker.ready;
      setRegistration(reg);
    }
    
    if (!reg) {
      console.error('❌ No service worker registration found');
      return null;
    }
    
    console.log('Registration:', reg);

    try {
      // Request notification permission
      console.log('🔔 Requesting notification permission...');
      const permission = await Notification.requestPermission();
      console.log('Permission result:', permission);
      
      if (permission !== 'granted') {
        console.log('❌ Notification permission denied');
        return null;
      }

      // Subscribe to push notifications
      console.log('📩 Subscribing to push notifications...');
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          'BEtKqaZtkDR3S96bGwp9XKQqCegmw461pEmTDI4aIqiYivUtVFYvl99Zo7_nA80B55Yv6E_bv0P7FE_E57-DrSk'
        )
      });

      console.log('✅ Push subscription successful:', sub);
      console.log('Subscription JSON:', sub.toJSON());
      setSubscription(sub);
      return sub;
    } catch (error) {
      console.error('❌ Push subscription failed:', error);
      console.error('Error details:', error.message);
      return null;
    }
  };

  return {
    registration,
    subscription,
    subscribeToPush,
    isSubscribed: !!subscription
  };
}

// Helper function to convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
